export default "__VITE_ASSET__DEpB2YBo__"